import { http } from '../shared/api';

export const listOffices = () => http.get('/api/offices');

export const createOffice = (body) => http.post('/api/offices', body);

export const updateOffice = (id, body) => http.put(`/api/offices/${id}`, body);

const SUPPLIER_PAGE_SIZE = 100;
const MAX_SUPPLIER_PAGES = 10;

const supplierPage = (page, { activeOnly, search }) => http.get('/api/electricity-suppliers', {
  params: {
    active_only: activeOnly,
    page,
    page_size: SUPPLIER_PAGE_SIZE,
    ...(search ? { search } : {}),
  },
});

/** Load the bounded canonical catalog while supporting the rollout's array shape. */
export async function listElectricitySuppliers({ activeOnly = true, search = '' } = {}) {
  const requestOptions = { activeOnly, search: search.trim() };
  const firstPage = await supplierPage(1, requestOptions);
  if (Array.isArray(firstPage)) return firstPage;
  const totalPages = Math.ceil(Number(firstPage?.total || 0) / SUPPLIER_PAGE_SIZE);
  if (totalPages > MAX_SUPPLIER_PAGES) {
    throw new Error('Electricity supplier catalog exceeds the supported page limit.');
  }
  if (totalPages <= 1) return firstPage?.items || [];
  const remainingPages = await Promise.all(
    Array.from(
      { length: totalPages - 1 },
      (_, index) => supplierPage(index + 2, requestOptions),
    ),
  );
  return [firstPage, ...remainingPages].flatMap(page => page?.items || []);
}

export const createElectricitySupplier = body => http.post(
  '/api/electricity-suppliers',
  body,
);

export const updateElectricitySupplier = (supplierId, body) => http.put(
  `/api/electricity-suppliers/${encodeURIComponent(supplierId)}`,
  body,
);

/** One approved assignment per Office and reporting year. */
export const listOfficeElectricityAssignments = fiscalYear => http.get(
  '/api/office-electricity-assignments',
  { params: { fiscal_year: Number(fiscalYear) } },
);

export const createOfficeElectricityAssignment = body => http.post(
  '/api/office-electricity-assignments',
  body,
);

export const updateOfficeElectricityAssignment = (assignmentId, body) => http.put(
  `/api/office-electricity-assignments/${encodeURIComponent(assignmentId)}`,
  body,
);
